export const createQueryParams = (params) =>
  Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');

export const GetQueryParameterByName = (name, target) => {
  // https://stackoverflow.com/a/30815999

  // new URLSearchParams(window.location.search).get('c') || ''

  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(target || window.location.search);
  return results === null ? '' : decodeURIComponent(results[1]);
};
